import style from './Container.module.css'

export const Container = ({ children, clname }) => {
    return (
        <div className={[style.container, clname].join(' ')}>
            {children}
        </div>
    )
}